
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取祭拜列表集合
    GetSacrificeSacrificeSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Sacrifice/SacrificeSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetSacrificeSacrificeSearchList2({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Sacrifice/SacrificeSearch2',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
     // 根据classId 获取对应祭品
     GetGroupSacrificeListByClassId({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Sacrifice/GetGroupSacrificeListByClassId',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
     // 获取套餐详情
     GetSacrificeSacrificePackageDetail({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Sacrifice/GetSacrificePackageDetail',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 根据classId 获取对应祭品
    AddSacrificeSacrificeBuyVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Sacrifice/SacrificeBuyVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
